module.exports = __webpack_public_path__ + "static/media/cards.6a7a4a7c.png";